import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

/** The newest writing from LimoLinkX and from the operators running on it, on the home page. */
export const LatestPosts = ({ limit = 3 }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/public/blog?include=all")
      .then(({ data }) => setPosts((data.posts || []).slice(0, limit)))
      .catch(() => setPosts([]));
  }, [limit]);

  if (!posts.length) return null;

  return (
    <section id="blog" data-testid="landing-blog" className="scroll-mt-20 border-y border-ink-600 bg-ink-800/40 py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-gold">From the blog</p>
            <h2 className="mt-3 font-display text-3xl text-slate-50 sm:text-4xl">
              Notes on running a car service.
            </h2>
          </div>
          <Link to="/blog" data-testid="landing-blog-all" className="font-mono text-xs uppercase tracking-widest text-gold hover:underline">
            All posts →
          </Link>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {posts.map((post) => (
            <Link key={post.id} to={post.path || `/blog/${post.slug}`}
              data-testid={`landing-blog-card-${post.slug}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-ink-600 bg-ink-900/60 transition-colors duration-200 hover:border-gold/50">
              {post.cover_url && (
                <img src={post.cover_url} alt="" className="aspect-[16/9] w-full object-cover" />
              )}
              <div className="flex flex-1 flex-col p-5">
                {post.source && (
                  <p className="font-mono text-[10px] uppercase tracking-widest text-gold/70">{post.source}</p>
                )}
                <p className="mt-1 font-display text-lg leading-snug text-slate-100">{post.title}</p>
                <p className="mt-2 line-clamp-3 text-sm text-slate-400">{post.excerpt}</p>
                <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-slate-500">
                  {(post.published_at || "").slice(0, 10)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
